const u_OnMutate = (targetNodes, callback) => {
  var observer = new MutationObserver(callback);
  // Notify me of everything!
  var observerConfig = {
    attributes: true,
    childList: true,
    characterData: true
  };
  targetNodes.forEach(node => {
    observer.observe(node, observerConfig);
  });
  return observer;
}

document.addEventListener('alpine:init', () => {
  Alpine.data('Swiper', (sw_options) => ({
    swiper: null,
    disable_on_breakpoints: '',
    init() {
      this.disable_on_breakpoints = this.$el.dataset.disableOnBreakpoints ? this.$el.dataset.disableOnBreakpoints.split(',') : [];
      this.InitSwiper();

      let resizeObserver = new ResizeObserver((e) => {
        this.InitSwiper();
      });
      resizeObserver.observe(this.$el);
    },
    InitSwiper() {
      if (!sw_options) {
        console.warn('No Swiper options provided');
        return;
      }

      // on swiper events
      sw_options.on = {
        slideChangeTransitionEnd(e) {
          // Fix pagination bullets not dynamically updating with slide change
          console.log('Slide changed: ', e.activeIndex);
          if (sw_options.pagination && document.querySelector(sw_options.pagination.el)) {
            let $paginate = document.querySelector(sw_options.pagination.el);
            if (!$paginate) return;
            let $active = $paginate.querySelector('.swiper-pagination-bullet-active');
            if ($active) {
              $active.classList.remove('swiper-pagination-bullet-active');
            }
            let $next = $paginate.querySelector('.swiper-pagination-bullet:nth-child(' + (e.activeIndex + 1) + ')');
            if ($next) {
              $next.classList.add('swiper-pagination-bullet-active');
            }
          }
        }
      };

      // Check if we need to disable the swiper on specific breakpoints
      let enable_swiper = true;
      this.disable_on_breakpoints.forEach(breakpoint => {
        if (window.matchMedia(breakpoint).matches) {
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }
          enable_swiper = false; // Disable Swiper
        }
      });
      if (!enable_swiper) return; // Don't initialize Swiper

      this.swiper = new Swiper(this.$el, sw_options);
    }
  }));

  Alpine.data('SubscriptionWidget', () => ({
    selectedPricing: '', 
    selectedFrequency: '',
    flags: {
      isSubscriptionPage: false
    },
    init() {
      this.selectedPricing = this.$el.dataset.selected_pricing || 'subscription';
      this.selectedFrequency = this.$el.dataset.selected_frequency;
      this.flags.isSubscriptionPage = window.location.pathname.includes('subscribe-save');

      // Restore persisted frequency when switching products (e.g. flavor siblings)
      try {
        let prefs = sessionStorage.getItem('mylk_subscription_prefs');
        if (prefs) {
          let { pricing, frequencyIndex } = JSON.parse(prefs);
          let $radios = this.$el.querySelectorAll('input[name="selling_plan"]');
          if (frequencyIndex >= 1 && frequencyIndex <= $radios.length) {
            this.selectedFrequency = $radios[frequencyIndex - 1].value;
          }
          if (pricing === 'subscription' || pricing === 'onetime') {
            this.selectedPricing = pricing;
          }
        }
      } catch (_) {}

      if (this.flags.isSubscriptionPage) {
        this.selectedPricing = 'subscription';
      }

      this.InitWatchers();
      setTimeout(this.UpdateFormSellingPlan.bind(this), 500);
      setTimeout(this.UpdateFormSellingPlan.bind(this), 1000);
    },
    InitWatchers() {
      this.$watch('selectedPricing', this.UpdateFormSellingPlan.bind(this));
      this.$watch('selectedFrequency', this.UpdateFormSellingPlan.bind(this));
      this.$watch('selectedPricing', this.UpdatePrice.bind(this));
    },
    UpdateFormSellingPlan() {
      // Find the product form and update the selling plan input value
      const form = document.querySelector(`#${this.$el.dataset.form_id}`);
      if (!form) return;
      const input = form.querySelector('input[name="selling_plan"]');
      if (!input) return;

      if (this.selectedPricing === 'subscription') {
        input.value = this.selectedFrequency;
      } 
      else {
        input.value = '';
      }
    },
    UpdatePrice() {

    }
  }));

  Alpine.data('GroupedProducts', () => ({
    async e_SwitchProduct(e, handle) {
      // console.log('Switching to product: ', handle);
      let $section = e.target.closest('section');
      let section_id = $section.id.replace('shopify-section-', '');
      let url = `/products/${handle}?section_id=${section_id}`;
      // console.log('URL: ', url);

      // Persist subscription frequency before switching
      let $widget = $section.querySelector('subscription-widget');
      if ($widget) {
        let $checked = $widget.querySelector('input[name="selling_plan"]:checked');
        let frequencyIndex = $checked
          ? Array.from($widget.querySelectorAll('input[name="selling_plan"]')).indexOf($checked) + 1
          : 1;
        let pricing = $widget.querySelector('.pricing-option.subscription.active') ? 'subscription' : 'onetime';
        sessionStorage.setItem('mylk_subscription_prefs', JSON.stringify({
          pricing,
          frequencyIndex
        }));
      }

      try {
        let response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        let html = await response.text();
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let new_section = doc.querySelector(`#shopify-section-${section_id}`) || doc.querySelector('.shopify-section');
        if (new_section) {
          // keep same flavours link from current page, so that it doesn't get overwritten
          $section.querySelector('.flavours-links .sibling-item.active').classList.remove('active');
          $section.querySelector(`.flavours-links .sibling-item[data-handle="${handle}"]`).classList.add('active');
          let new_flavours_links = new_section.querySelector('.flavours-links');
          if (new_flavours_links) {
            new_flavours_links.innerHTML = $section.querySelector('.flavours-links').innerHTML;
          }
          else {
            // If the new section doesn't have flavours links, add the current one to it
            new_section.querySelector('subscription-widget').insertAdjacentHTML('beforebegin', $section.querySelector('.flavours-links').outerHTML);
          }
          let prefs = sessionStorage.getItem('mylk_subscription_prefs');
          $section.replaceWith(new_section);
          // Apply persisted frequency after Alpine initializes the new widget
          if (prefs) {
            let applyPrefs = () => {
              let $widget = new_section.querySelector('subscription-widget');
              if ($widget && window.Alpine) {
                let data = Alpine.$data($widget);
                if (data) {
                  try {
                    let { pricing, frequencyIndex } = JSON.parse(prefs);
                    let $radios = $widget.querySelectorAll('input[name="selling_plan"]');
                    if (frequencyIndex >= 1 && frequencyIndex <= $radios.length) {
                      data.selectedFrequency = $radios[frequencyIndex - 1].value;
                    }
                    if (pricing === 'subscription' || pricing === 'onetime') {
                      data.selectedPricing = pricing;
                    }
                    return true;
                  } catch (_) {}
                }
              }
              return false;
            };
            if (!applyPrefs()) {
              setTimeout(() => applyPrefs(), 100);
            }
          }
        }
        else {
          console.error('New section not found in fetched HTML');
        }
      }
      catch (error) {
        console.error('Error fetching product data:', error);
      }
    }
  }));

  Alpine.data('ProductForm', () => ({
    init() {
      this.OnBundleLoad();
    },
    OnBundleLoad() {
      let $addToCart = this.$el.querySelector('.buy-buttons button');
      
      // Use u_OnMutate to watch for #simple-bundles-io-options
      const DisableForm = () => {
        let $bundleOptions = document.querySelector('#simple-bundles-io-options');
        if ($bundleOptions) {
          // console.log('#simple-bundles-io-options loaded');
          // For each dropdown (select) inside $bundleOptions, make the first option selected
          $bundleOptions.querySelectorAll('select').forEach(select => {
            let $firstOption = select.querySelector('option:first-child');
            $firstOption.disabled = false; // Ensure the first option is enabled
            $firstOption.selected = true;
            $firstOption.disabled = true; // Disable the first option to prevent re-selection
            if (select.options.length > 0) {
              select.selectedIndex = 0;
              // Optionally, trigger change event if needed:
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          // Disable the add to cart button until an option is selected
          if ($addToCart) {
            $addToCart.disabled = true;
            $addToCart.textContent = 'Choose All Options';

            // Listen for changes on the dropdowns to enable the add to cart button
            $bundleOptions.querySelectorAll('select').forEach(select => {
              select.addEventListener('change', () => {
                let allSelected = Array.from($bundleOptions.querySelectorAll('select')).every(s => s.value);
                if (allSelected) {
                  $addToCart.disabled = false;
                  $addToCart.textContent = 'Add Bundle to Cart';
                } else {
                  $addToCart.disabled = true;
                  $addToCart.textContent = 'Choose All Options';
                }
              });
            });
          }

          if (observer) observer.disconnect();
          return true;
        }
        return false;
      };

      // In case the element is already present
      if (DisableForm()) return;

      // Use u_OnMutate to observe document.body
      const observer = u_OnMutate([document.body], () => {
        setTimeout(DisableForm, 500); // Delay to ensure the element is fully rendered
      });
    }
  }));

  Alpine.data('ScrollTo', () => ({
    e_ScrollTo(selector) {
      let $target = document.querySelector(selector);
      if ($target) {
        $target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }));
});